// constants
import Web3EthContract from "web3-eth-contract";
// import Web3 from "web3";

import { createAlchemyWeb3 } from "@alch/alchemy-web3";

// log
import { fetchData } from "../data/dataActions";
// import Web3Modal from "web3modal";
import CoinbaseWalletSDK from '@coinbase/wallet-sdk';
import WalletConnectProvider from "@walletconnect/web3-provider";
import Web3Modal from "web3modal";


const chainId = 1;
const rpc = "https://eth-mainnet.alchemyapi.io/v2/qGZES2yXt4ddmVxVS7ZFj56oBs6EWQLd";
const appName = "NGHTMRE DRMVRSE TOUR"

const nftContractAddress = "0xa063ae92359d46f0f48dc225b51bbaca5ee224d4";
const minterContractAddressMerkleTree = "0x78027647e6c0158134eefd5072d888cfb41ffcea";
const minterContractAddressFreebie = "0xd5d9a785d6a70428f7eb408d573af23c474047c8";


async function apiCallValidate(ethAddress) {
    const url = `https://nghtmre-free-mint.netlify.app/.netlify/functions/validate?ethAddress=` + encodeURIComponent(ethAddress);
    try {
        const response = await fetch(url);
        const data = await response.json();
        return data;
    } catch (err) {
        return { status: -10 };
    }
};

const providerOptions = {
    /* See Provider Options Section */
    coinbasewallet: {
        package: CoinbaseWalletSDK, // Required
        options: {
            appName: appName, // Required
            //  infuraId: "INFURA_ID", // Required
            rpc: rpc, // Optional if `infuraId` is provided; otherwise it's required
            chainId: chainId, // Optional. It defaults to 1 if not provided
            darkMode: false // Optional. Use dark theme, defaults to false
        }
    },
    walletconnect: {
        package: WalletConnectProvider, // required
        options: {
            rpc: {
                4: rpc, /// TODO -> chainId: rpc
            },

            // infuraId: "INFURA_ID" // required
        }
    }
};

const web3Modal = new Web3Modal({
    network: "mainnet", // optional
    cacheProvider: true, // optional
    providerOptions // required
  });



  

const disconnected = () => {
    return {
        type: "DISCONNECTED",
    };
};


const connectRequest = () => {
    return {
        type: "CONNECTION_REQUEST",
    };
};

const connectSuccess = (payload) => {
    return {
        type: "CONNECTION_SUCCESS",
        payload: payload,
    };
};

const connectFailed = (payload) => {
    return {
        type: "CONNECTION_FAILED",
        payload: payload,
    };
};

const updateAccountRequest = (payload) => {
    return {
        type: "UPDATE_ACCOUNT",
        payload: payload,
    };
};

const loadFromConfigFolder = async(filename) => {
    console.log(`/config/${filename}`);
    const abiResponse = await fetch(`/config/${filename}`, {
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    });
    return await abiResponse.json();

};


export const disconnect = () => {
    return async(dispatch) => {
        await web3Modal.clearCachedProvider();
        dispatch(disconnected());

    }
};

export const connect = () => {
    return async(dispatch) => {

        dispatch(connectRequest());

        await web3Modal.clearCachedProvider();
        const provider = await web3Modal.connect();
        await provider.enable();

        const web3 = createAlchemyWeb3(
            rpc,
            { writeProvider: provider }
          );

        // const web3 = new Web3(provider);


        const abiNFT = await loadFromConfigFolder('nft-abi.json');
        // const abiMinter = await loadFromConfigFolder('minter-merkle-tree-abi.json');
        const abiMinter = await loadFromConfigFolder('minter-freebie-abi.json');
        const CONFIG = await loadFromConfigFolder("config.json");

        // const { ethereum } = window;
        // const metamaskIsInstalled = ethereum && ethereum.isMetaMask;
        // if (metamaskIsInstalled) {
            // Web3EthContract.setProvider(ethereum);
            // let web3 = new Web3(ethereum);
            try {
 
                const chainId = await web3.eth.getChainId();
                console.log(chainId);

                const networkId = await web3.eth.net.getId();
                // console.log('NETWORK ID');
                // console.log(networkId);


                const accounts = await web3.eth.getAccounts();
                // console.log('ACCOUNTS');
//                console.log(accounts);


 
                // const accounts = await ethereum.request({
                //     method: "eth_requestAccounts",
                // });
                // const networkId = await ethereum.request({

                if (networkId == CONFIG.NETWORK.ID) {
                    const proof = await apiCallValidate(accounts[0]);

                    // const SmartContractObj = new Web3EthContract(
                    //     abi,
                    //     CONFIG.CONTRACT_ADDRESS
                    // );

                    const minterSmartContractFreebie = new web3.eth.Contract( abiMinter, minterContractAddressFreebie,)

                    const nftSmartContract = new web3.eth.Contract( abiNFT, nftContractAddress,)

                    // const minterSmartContract = new Web3EthContract(
                    //     abiMinter,
                    //     minterContractAddress, // CONFIG.CONTRACT_ADDRESS
                    // );



                    dispatch(
                        connectSuccess({
                            account: accounts[0],
                            nftSmartContract: nftSmartContract,
                            minterSmartContract: minterSmartContractFreebie,
                            web3: web3,
                            proof: proof
                        })
                    );

                    // Add listeners start
                    provider.on("accountsChanged", (accounts) => {
                        dispatch(updateAccount(accounts[0]));
                    });
                    provider.on("chainChanged", () => {
                        window.location.reload();
                    });
                    // Add listeners end
                } else {
                    dispatch(connectFailed(`Change network to ${CONFIG.NETWORK.NAME}.`));
                }
            } catch (err) {
                console.log(err);
                dispatch(connectFailed("Something went wrong."));
            }
        // } else {
        //     dispatch(connectFailed("Install Metamask."));
        // }
    };
};

export const updateAccount = (account) => {
    return async(dispatch) => {
        dispatch(updateAccountRequest({ account: account }));
        dispatch(fetchData(account));
    };
};